// extracted by mini-css-extract-plugin
export default {"formButton":"formButton__K2Rvlo","formInput":"formInput__fmMSFW","form":"form__RCXpD5"};